// extracted by css-extract-rspack-plugin
export default {"docItemContainer":"docItemContainer_Rv5Z","docItemCol":"docItemCol_YAwJ"};